import { DataGroup } from '@/constants/datagroup'
import type { DataGroupType } from '@/types/datagroup'

export const hasCrossRetailer = (app?: string): boolean => {
  if (!app) return false
  return app === 'rmms' || app === 'rmm'
}

export const isAgencyDatagroup = (datagroupType: DataGroupType): boolean =>
  datagroupType === DataGroup.AGENCY
